import {lemon, lemonReady} from "../common/lemon";
import {buildRecommendTop5} from "../common/recommend/recomment_goods";

lemonReady(function (){
  let recommendList = lemon("#recommendList");
  buildRecommendTop5({list_container: recommendList});
});